import { t } from "i18next";

export const klaviyoListTypeToHumanReadable = (listType?: IKlaviyoListType) =>
  listType === "DOUBLE_OPT_IN"
    ? t("settings.integration.klaviyoLists.modal.doubleOptIn")
    : t("settings.integration.klaviyoLists.modal.singleOptIn");
